import { TYPE_SIZES, TYPE_PLATFORM } from '../../utils/globalConst.js';

//
var TYPES_LIST = Object.freeze({
  default: {
    value: 'default',
    className: ''
  },
  info: {
    value: 'info',
    className: '_info'
  }
});
var script = {
  name: 'ElementItem',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    isContainer: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: TYPES_LIST.default.value
    },
    size: {
      type: String,
      default: TYPE_SIZES.normal.value
    },
    platform: {
      type: String,
      default: TYPE_PLATFORM.mobile.value
    }
  },
  computed: {
    bindAttrs: function bindAttrs() {
      var attrs = Object.assign({}, this.$attrs);

      if (this.tag === 'button') {
        attrs.type = 'button';
      }

      return attrs;
    },

    classList: function classList() {
      var obj;

      return ( obj = {}, obj[TYPE_SIZES.small.className] = this.size === TYPE_SIZES.small.value, obj[TYPE_SIZES.large.className] = this.size === TYPE_SIZES.large.value, obj['_container'] = this.isContainer, obj[TYPES_LIST.info.className] = this.type === TYPES_LIST.info.value, obj[TYPE_PLATFORM.desktop.className] = this.platform === TYPE_PLATFORM.desktop.value, obj );
    }

  },
  methods: {
    handlerClickItem: function handlerClickItem(event) {
      this.$emit('click', event);
    },

    onFocus: function onFocus() {
      if (this.$refs.element.focus) {
        this.$refs.element.focus();
      }
    }

  }
};

export default script;
